import { render, staticRenderFns } from "./FragmentIcon.vue?vue&type=template&id=8e8dbf20"
import script from "./FragmentIcon.vue?vue&type=script&lang=js"
export * from "./FragmentIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports